<template>
    <div>
      <div  v-if="manufacturers != 0">
        <component :is="'manufacturers'+manufacturers" :id="id" :type="type" :info="info"></component>
      </div>
    </div>
  </template>
  
  <script>
  import manufacturers1 from '../components/manufacturers1.vue'
  import manufacturers2 from '../components/manufacturers2.vue'
  import manufacturers3 from '../components/manufacturers3.vue'
  import manufacturers4 from '../components/manufacturers4.vue'
  import manufacturers5 from '../components/manufacturers5.vue'
  import manufacturers6 from '../components/manufacturers6.vue'
  import manufacturers7 from '../components/manufacturers7.vue'
  import manufacturers8 from '../components/manufacturers8.vue'
  import manufacturers9 from '../components/manufacturers9.vue'
  import manufacturers10 from '../components/manufacturers10.vue'

  export default {
    data(){
      return{
        manufacturers:0,
        id:0,
        type:'产品铭牌',
        info:{}
      }
    },
    components:{
        manufacturers1,
        manufacturers2,
        manufacturers3,
        manufacturers4,
        manufacturers5,
        manufacturers6,
        manufacturers7,
        manufacturers8,
        manufacturers9,
        manufacturers10
    },
    methods:{
      // getUrlKey(name) {
      //     return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      // }
    },
    mounted(){
      // https://www.dianzibiaopai.top/#/?1.10.0.0
      let href = location.href
      let params = href.split('?')[1]
      params = params.split('.')
        this.manufacturers = params[0]
        this.id = params[1]
        console.log(this.id)
        // alert(href)
        this.type = params[2] == 0 ?'产品铭牌':'产品质量证明'
        let title = ''
        switch(this.manufacturers){
            case '1':
              title = '山西高义电子标牌'
            break;
            case '2':
              if(this.type == '产品铭牌') title = '山西建龙电子标牌'
            break;  
            case '3':
              if(this.type != '产品铭牌') title = '信息'
            break;
            case '4':
              title = '山西建邦集团电子标牌'
            break;  
            case '5':
              title = '钢材一键查'
            break;
            
            case '6':
            case '9':
            title = '晋钢电子标牌'
            break;  
            case '7':
              title = '首钢长钢公司电子标牌'
            break;  
            case '8':
              if(this.type == '产品铭牌') title = '建龙电子标牌'
            break
            case '10':
              title = '内蒙古亚新隆顺特钢有限公司'
              break
        }
        document.title=title
        // this.$http.get('/mp/mp/info?id='+this.id).then(res=>{
        
        this.$http.get('/mp/info?id='+this.id).then(res=>{
            let resData = res.data
            const keys = ['chemistrydesc','physicsdesc','proof']
            for(let i of keys){
              if(resData[i]){
                resData[i] = resData[i].replace('<p><br></p>','')
              }
            }
            this.info = resData
        })
    },
    watch:{
     
    }
  }
  </script>
  
  <style>
  
  </style>


// WEBPACK FOOTER //
// src/pages/home.vue